var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 0.666504C3.93317 0.666504 0.666504 3.93317 0.666504 7.99984C0.666504 12.0665 3.93317 15.3332 7.99984 15.3332C12.0665 15.3332 15.3332 12.0665 15.3332 7.99984C15.3332 3.93317 12.0665 0.666504 7.99984 0.666504ZM8.6665 7.99984V11.9998H7.33317V7.99984H6.6665V6.6665H7.99984C8.39984 6.6665 8.6665 6.93317 8.6665 7.33317V7.99984ZM6.6665 4.33317C6.6665 4.8665 7.13317 5.33317 7.6665 5.33317C8.19984 5.33317 8.6665 4.8665 8.6665 4.33317C8.6665 3.79984 8.19984 3.33317 7.6665 3.33317C7.13317 3.33317 6.6665 3.79984 6.6665 4.33317Z",
    fill: "#262626"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 0.666504C3.93317 0.666504 0.666504 3.93317 0.666504 7.99984C0.666504 12.0665 3.93317 15.3332 7.99984 15.3332C12.0665 15.3332 15.3332 12.0665 15.3332 7.99984C15.3332 3.93317 12.0665 0.666504 7.99984 0.666504ZM8.6665 7.99984V11.9998H7.33317V7.99984H6.6665V6.6665H7.99984C8.39984 6.6665 8.6665 6.93317 8.6665 7.33317V7.99984ZM6.6665 4.33317C6.6665 4.8665 7.13317 5.33317 7.6665 5.33317C8.19984 5.33317 8.6665 4.8665 8.6665 4.33317C8.6665 3.79984 8.19984 3.33317 7.6665 3.33317C7.13317 3.33317 6.6665 3.79984 6.6665 4.33317Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 26,
    height: 26,
    fill: "#0C74DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ea2a121991f98ffed55c83e556df19ad.svg";
export { ForwardRef as ReactComponent };